import styled from 'styled-components';
import { rootBackgroundColor } from '@styles/styled/variables';

const TimelinePageStyled = styled.div`
  height: 100%;
  background-color: ${rootBackgroundColor};
  margin: 8px 8px 0 8px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export default TimelinePageStyled;
